module.exports = __webpack_public_path__ + "Steve Li-3b39bf9e.png";